import React from 'react';
import Icon from '../../../components/AppIcon';

const BiodiversityHealth = ({ species }) => {
  const getHealthColor = (status) => {
    switch (status) {
      case 'healthy':
        return 'text-success';
      case 'monitoring':
        return 'text-warning';
      case 'critical':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const getHealthIcon = (status) => {
    switch (status) {
      case 'healthy':
        return 'CheckCircle';
      case 'monitoring':
        return 'AlertCircle';
      case 'critical':
        return 'AlertTriangle';
      default:
        return 'Circle';
    }
  };

  const getHealthPercentage = (status) => {
    switch (status) {
      case 'healthy':
        return 85;
      case 'monitoring':
        return 60;
      case 'critical':
        return 30;
      default:
        return 0;
    }
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-semibold text-foreground">Biodiversity Health</h3>
        <div className="flex items-center gap-2">
          <Icon name="Activity" size={20} color="var(--color-success)" />
          <span className="text-sm font-medium text-success">78% Overall</span>
        </div>
      </div>
      <div className="space-y-4">
        {species?.map((item) => (
          <div key={item?.id} className="border border-border rounded-lg p-4 animation-organic hover:border-primary/50">
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <h4 className="font-medium text-foreground mb-1">{item?.name}</h4>
                <p className="text-sm text-muted-foreground">{item?.scientificName}</p>
              </div>
              <div className={`flex items-center gap-2 ${getHealthColor(item?.status)}`}>
                <Icon name={getHealthIcon(item?.status)} size={18} color="currentColor" />
                <span className="text-sm font-medium">{item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)}</span>
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Population</span>
                <span className="font-medium text-foreground">{item?.population}</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                <div 
                  className={`h-full rounded-full transition-all duration-500 ${
                    item?.status === 'healthy' ? 'bg-success' : 
                    item?.status === 'monitoring' ? 'bg-warning' : 'bg-error'
                  }`}
                  style={{ width: `${getHealthPercentage(item?.status)}%` }}
                ></div>
              </div>
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>Last Survey: {item?.lastSurvey}</span>
                <span>Trend: {item?.trend}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BiodiversityHealth;